import React, { useEffect, useState } from 'react';
import { Navbar, Container, Row, Col } from 'react-bootstrap';
import parse from 'html-react-parser';
import { useLocation } from 'react-router-dom';
import UserWayAccessibilityMenu from "./UserWayAccessibilityMenu/index.js";
import Image from 'react-bootstrap/Image';
import SunWestLogo from '../Images/SunWest-Logo.png'

export default function Main() {
    const [content, setContent] = useState(null);
    const location = useLocation();
    const [isScrolled, setIsScrolled] = useState(false);
    const [showMobileNav, setShowMobileNav] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);

    // useEffect(() => {
    //     const fetchData = async () => {
    //         const response = await fetch(`${process.env.REACT_APP_CDN_JSONS_PATH}esignConsent.json`);
    //         const data = await response.json();
    //         const isSpanish = location.pathname.endsWith('/es');
    //         setContent(isSpanish ? data.es : data.en);
    //     };
    //     fetchData();
    // }, [location.pathname]);


    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
            if (window.innerWidth < 991) {
                if (window.scrollY > lastScrollY) {
                    setShowMobileNav(false);
                } else {
                    setShowMobileNav(true);
                }
                setLastScrollY(window.scrollY);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [lastScrollY]);

    // if (!content) return <p>Loading...</p>;

    //     return (
    //         <div className='main-page'>
    //             {/* Navbar */}
    //             <Navbar
    //                 expand="lg"
    //                 fixed="top"
    //                 className={`custom-navbar ${isScrolled ? 'scrolled' : ''} ${!showMobileNav ? 'hidden' : ''}`}
    //             >
    //                 <Container>
    //                     <div className='navlogo d-flex'>
    //                     <Navbar.Brand href="#">
    //                         <Image src={content.logoPath} alt={content.logoAlt} height="40" />
    //                     </Navbar.Brand>
    //                     <UserWayAccessibilityMenu color="black" width={40} height={40} />
    //                     </div>
    //                 </Container>
    //             </Navbar>

    //             {/* Main Content */}
    //             <Container className="">
    //                 <Row className="justify-content-center">
    //                     {/* <Col xs={8} sm={6} md={5} className="p-3">
    //                         <Image src={content.logoPath} fluid alt={content.logoAlt} />
    //                     </Col> */}
    //                     <Col xs={12} className="text-center pt-5">
    //                         <h5>{parse(content.heading)}</h5>
    //                     </Col>

    //                     <Col xs={12} className="mt-2 text-justify">
    //                         {content.sections.map((section, index) => (
    //                             <div key={index}>
    //                                 {section.title && <p className="mb-1"><strong>{parse(section.title)}</strong></p>}
    //                                 {section.text && <p>{parse(section.text)}</p>}
    //                                 {section.list && (
    //                                     <ul>
    //                                         {section.list.map((item, idx) => (
    //                                             <li key={idx}>{parse(item)}</li>
    //                                         ))}
    //                                     </ul>
    //                                 )}
    //                             </div>
    //                         ))}
    //                     </Col>
    //                 </Row>
    //             </Container>
    //         </div>
    //     );
    // }

    return (
        <div className='main-page'>

            <Navbar
                expand="lg"
                fixed="top"
                className={`custom-navbar ${isScrolled ? 'scrolled' : ''} ${!showMobileNav ? 'hidden' : ''}`}
            >
                <Container>
                    <div className='navlogo d-flex'>
                        <Navbar.Brand >
                            <a href="https://www.swmc.com" rel='noopener noreferrer' target='_blank'>
                            <Image src={SunWestLogo} alt="Sun West Logo" height="40" />
                            </a>
                        </Navbar.Brand>
                        <UserWayAccessibilityMenu color="black" width={40} height={40} />
                    </div>
                </Container>
            </Navbar>


            <Container>
            <Row className="justify-content-center">

                <Col xs={12} className="text-center pt-3">
                    <h5><u>E-SIGN CONSENT TO USE ELECTRONIC RECORDS AND SIGNATURES</u></h5>
                </Col>

                <Col xs={12} className="mt-2 text-justify">
                    <p>From time to time, Sun West Mortgage Company, Inc. (we, us or Company) may be required by law to provide to you certain written notices or disclosures. In addition, we may need to send you agreements and other documents that you will need to sign. Described below are the terms and conditions for providing to you such notices, disclosures and documents electronically, and for obtaining your electronic signature. Please read the information below carefully and thoroughly. If you can access this information electronically to your satisfaction and agree to these terms and conditions, please confirm your agreement by clicking the ‘I agree’ button at the bottom of this document.</p>

                    <p className="mb-1"><strong>All notices and disclosures will be sent to you</strong></p>

                    <p>In order to provide you with disclosures electronically, we need your permission. Please read the procedures and disclosures below, which provide that if you agree to receive disclosures from us electronically, you need to tell us by clicking the &quot;I Agree&quot; button, below. If you agree, we will provide electronically all required notices, disclosures, authorizations, acknowledgements, and other documents that are required to be provided or made available to you during the course of our relationship with you, which may involve more than one transaction or event. To reduce the chance of you inadvertently not receiving any notice or disclosure, we prefer to provide all of the required notices and disclosures to you by the same method and to the same address. Thus, you can receive all the disclosures and notices either (1) electronically or (2) in paper format through the paper mail delivery system. If you click the 'I agree' button below, you will be certifying that your computer and software meet the minimum standards set forth below and that you agree to receive all notices, disclosures and documents electronically, and to sign agreements and other documents electronically. Please note that if you do not agree to electronic receipt and signing during this step of the application, we will send all notices, disclosures and documents in paper form.</p>

                    <p className="mb-1"><strong>Getting paper copies</strong></p>
                    <p>Even if you choose to receive and sign notices, disclosures and documents electronically, you may at any time request from us a paper copy of any material provided or made available electronically to you by us. You will also have the ability to download and print documents we send to you electronically. To request delivery from us of paper copies of the notices, disclosures or documents previously provided by us to you electronically, you must send us an e-mail to <a href="mailto:esign@swmc.com"> esign@swmc.com</a>. In the email body of such request you must state your e-mail address, full name, US Postal address, and telephone number. No fee will be charged for providing a paper copy.</p>

                    <p className="mb-1"><strong>Withdrawing your Consent</strong></p>
                    <p>If you choose to receive notices and disclosures from us electronically at this time, you may at any time change your mind and tell us that thereafter you want to receive required notices and disclosures only in paper format. To inform us that you no longer want to receive future notices and disclosures in electronic format you may send us an e-mail to <a href="mailto:esign@swmc.com"> esign@swmc.com</a>. In the email body of such request you must state your e-mail address, full name, US Postal address, and telephone number. No fees will be charged for providing paper copies if you withdraw your consent.</p>

                    <p className="mb-1"><strong>Consequences of changing your Consent</strong></p>
                    <p>If you elect to receive required notices and disclosures only in paper format, it may slow the speed at which we can complete certain steps in transactions with you and delivering services to you because we will need first to send the required notices or disclosures to you in paper format, and then wait until we receive back from you your acknowledgment of your receipt of such paper notices or disclosures. However, no fees will be charged for providing paper copies.</p>

                    <p className="mb-1"><strong>To advise Sun West Mortgage Company, Inc. of your new e-mail</strong></p>
                    <p>To let us know of a change in your e-mail address where we should send notices and disclosures electronically to you, you must send an email message to us at <a href="mailto:esign@swmc.com"> esign@swmc.com</a> and in the body of such request you must state: your previous e-mail address, your new e-mail address. We do not require any other information from you to change your email address.</p>

                    <p className="mb-1"><strong>How to contact Sun West Mortgage Company, Inc. about anything</strong></p>
                    <p>You may contact us to ask questions, seek assistance, update other contact information in addition to your email, or otherwise by sending an email message to <a href="mailto:esign@swmc.com"> esign@swmc.com</a>.</p>

                    <p className="mb-1"><strong>Required hardware and software Operating Systems</strong></p>
                    <p className="mb-2"><u>Operating System</u>: Windows&reg; 2000, Windows&reg; XP, Windows Vista&reg;; Mac OS&reg; X</p>

                    <p className="mb-2"><u>Browsers</u>: Final release versions of Internet Explorer&reg; 6.0 or above (Windows only); Mozilla Firefox 2.0 or above (Windows and Mac); Safari&trade; 3.0 or above (Mac only)</p>
                    <p className="mb-2"><u>PDF Reader</u>: Acrobat&reg; or similar software may be required to view and print PDF files</p>
                    <p className="mb-2"><u>Screen Resolution</u>: 800 x 600 minimum</p>
                    <p className="mb-0"><u>Enabled Security Settings</u>: Allow per session cookies</p>
                    <small>**These minimum requirements are subject to change. If these requirements change, you will be asked to re-accept the disclosure.</small>

                    <p className="mt-3 mb-1"><strong>Acknowledging your access and consent to receive materials electronically</strong></p>
                    <p>In order to provide you with notices, disclosures and documents electronically, we need to confirm that you are able to access these materials, and that you can print and/or store them electronically. To confirm to us that you can access this information electronically, which will be similar to other electronic notices and disclosures that we will provide to you, we ask that you verify that you were able to read this electronic disclosure and that you also were able to print on paper or electronically save this disclosure for your future reference and access.</p>

                    <p className="mb-1">I confirm that:</p>
                    <ul>
                        <li>I can access and read this Electronic &quot;ELECTRONIC RECORD AND SIGNATURE DISCLOSURES&quot; document; and</li>
                        <li>I can print the disclosure on paper, or save the disclosure to a location where I can store it and from which I can print it, for future reference and access; and</li>
                        <li>Unless and until I notify Sun West Mortgage Company, Inc. in the manner described above that I no longer consent, I agree to receive exclusively through electronic means all notices, disclosures, authorizations, acknowledgements, and other documents that are required to be provided or made available to me by Sun West Mortgage Company, Inc. during the course of my relationship with it, and I agree that all documents requiring my signature may be signed electronically using the means provided by Sun West Mortgage Company, Inc. for doing so.
                        </li>
                    </ul>
                </Col>
            </Row>
        </Container>

        </div>



    );
}
